import { useState, useEffect } from 'react';

const navLinks = [
  { label: 'サービス', href: '#service' },
  { label: '特徴', href: '#features' },
  { label: '実績', href: '#results' },
  { label: '料金', href: '#pricing' },
  { label: 'FAQ', href: '#faq' },
  { label: 'お問い合わせ', href: '#contact' },
];

export default function Navbar() {
  const [scrolled, setScrolled] = useState(false);
  const [menuOpen, setMenuOpen] = useState(false);

  useEffect(() => {
    const handleScroll = () => setScrolled(window.scrollY > 60);
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const handleNav = (e: React.MouseEvent<HTMLAnchorElement>, href: string) => {
    e.preventDefault();
    const target = document.querySelector(href);
    if (target) {
      target.scrollIntoView({ behavior: 'smooth' });
    }
    setMenuOpen(false);
  };

  return (
    <header
      className={`fixed top-0 left-0 w-full z-50 transition-all duration-300 ${
        scrolled ? 'bg-white border-b border-gray-100' : 'bg-transparent'
      }`}
    >
      <nav className="max-w-6xl mx-auto px-4 md:px-6 h-14 md:h-36 flex items-center justify-between">
        <a
          href="#"
          onClick={(e) => { e.preventDefault(); window.scrollTo({ top: 0, behavior: 'smooth' }); }}
          className="cursor-pointer"
        >
          <img
            src="https://storage.readdy-site.link/project_files/54722571-b9ba-49ee-a788-8f8a3d9e793f/07172bbf-28a4-4716-a4ee-585cff9bfcba_scout_boost_logo_.png?v=683c30006aab33bfd4298263e9181637"
            alt="ScoutPro"
            className={`h-[77px] md:h-[132px] w-auto object-contain transition-all duration-300 ${
              scrolled ? '' : 'brightness-0 invert'
            }`}
          />
        </a>

        {/* Desktop Links */}
        <ul className="hidden md:flex items-center gap-5 lg:gap-7">
          {navLinks.slice(0, -1).map((link) => (
            <li key={link.href}>
              <a
                href={link.href}
                onClick={(e) => handleNav(e, link.href)}
                className={`text-sm font-medium transition-colors duration-200 cursor-pointer hover:opacity-70 ${
                  scrolled ? 'text-[#444]' : 'text-white/90'
                }`}
              >
                {link.label}
              </a>
            </li>
          ))}
          <li>
            <a
              href="#contact"
              onClick={(e) => handleNav(e, '#contact')}
              className={`text-sm font-medium px-5 py-2 rounded-full transition-all duration-200 cursor-pointer whitespace-nowrap ${
                scrolled
                  ? 'bg-[#1a2e4a] text-white hover:bg-[#263f66]'
                  : 'bg-white text-[#1a2e4a] hover:bg-white/90'
              }`}
            >
              お問い合わせ
            </a>
          </li>
        </ul>

        {/* Mobile Hamburger */}
        <button
          className="md:hidden cursor-pointer"
          onClick={() => setMenuOpen(!menuOpen)}
          aria-label="メニュー"
        >
          <i
            className={`text-2xl transition-colors duration-300 ${
              scrolled ? 'text-[#1a2e4a]' : 'text-white'
            } ${menuOpen ? 'ri-close-line' : 'ri-menu-line'}`}
          />
        </button>
      </nav>

      {/* Mobile Menu */}
      {menuOpen && (
        <div className="md:hidden bg-white border-t border-gray-100 px-6 py-4">
          <ul className="flex flex-col gap-4">
            {navLinks.map((link) => (
              <li key={link.href}>
                <a
                  href={link.href}
                  onClick={(e) => handleNav(e, link.href)}
                  className="text-sm font-medium text-[#333] cursor-pointer hover:text-[#1a2e4a]"
                >
                  {link.label}
                </a>
              </li>
            ))}
          </ul>
        </div>
      )}
    </header>
  );
}
